/** Fieldset wrapper for the two From/To pairs (Figma 32:194754 / 32:194757). Mirrors
 *  <FormField>'s vertical rhythm and label look so the groups line up with the selects above. */
.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  padding: 0 var(--space-2);
  font-size: 14px;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

.row {
  display: flex;
  gap: var(--space-6); // Figma dimensions/spacing/6 = 24px between From and To.
}

// Each <FormField> carries its own 16px bottom margin; inside the fieldset that would stack with
// the fieldset's own, leaving a pair 32px from the next field while a select sits 16px away.
.row > * {
  margin-bottom: 0;
}
